import type { Props } from "./index.tsx"

export const Stack = ({ className, kind }: Props) => {
  if (kind === "outline") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        fill="none"
        viewBox="0 0 16 16"
        className={className}
      >
        <path fill="currentColor" d="M14 14H2V6h12v8ZM3 13h10V7H3v6Zm10-8H3V4h10v1Zm-2-2H5V2h6v1Z" />
      </svg>
    )
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      fill="none"
      viewBox="0 0 16 16"
      className={className}
    >
      <path fill="currentColor" d="M14 14H2V6h12v8Zm-1-9H3V4h10v1Zm-2-2H5V2h6v1Z" />
    </svg>
  )
}
